import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
  return _openBlock(), _createBlock(_component_b_form_checkbox, {
    modelValue: $options.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.value = $event),
    disabled: $props.disabled,
    class: "app-checkbox"
  }, null, 8, ["modelValue", "disabled"]);
}